/**
 * Shown when a property can't enter rehab because it's actively listed for
 * rent ("Move to Rehab" on the pipeline, or "Start Rehab" on the Rehab page).
 * Acknowledge-only modal — the user must remove the listing from Rentals first.
 */
import { useNavigate } from "react-router-dom";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { RENTAL_LISTING_BLOCK_MESSAGE } from "@/lib/rental-listing-guard";

interface RentalListingBlockedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RentalListingBlockedDialog({
  open,
  onOpenChange,
}: RentalListingBlockedDialogProps) {
  const navigate = useNavigate();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Listed for rent</AlertDialogTitle>
          <AlertDialogDescription>
            {RENTAL_LISTING_BLOCK_MESSAGE}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Close</AlertDialogCancel>
          <AlertDialogAction onClick={() => navigate("/rentals")}>
            Go to Rentals
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
